export const BACKEND_BASE_URL =
  import.meta.env.VITE_API_URL ||
  import.meta.env.VITE_BACKEND_BASE_URL ||
  'http://localhost:3001/api'

export const SKIP_AUTH_CHECK_ENDPOINTS = [
  '/student/courses',
  '/student/blogs',
  '/student/teachers',
  '/student/categories',
  '/student/tags',
  '/student/testimonials',
  '/student/faqs',
  '/student/plans',
  '/student/subscriptions',
  '/student/contact',
  '/auth/login',
]
